import React from 'react';
// import { useSelector } from 'react-redux';
import AuthForm from '../../components/AuthForm/AuthForm';
import AuthLayout from '../../layout/AuthLayout/AuthLayout';

export default function AuthScreen() {
	// const user = useSelector((state) => state.user);

	// console.log('user', user);

	return (
		<AuthLayout>
			<AuthForm />
		</AuthLayout>
	);
}
